import { RangeType } from '@/interfaces/common.interfaces';

function instanceOfRange(object: any): object is RangeType {
  return (
    Array.isArray(object) &&
    object.length === 2 &&
    object.every(n => typeof n === 'number' && !Number.isNaN(n))
  );
}

export default instanceOfRange;
